import { Skeleton } from '@mantine/core';

export function TestSuiteSkeleton() {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Skeleton
          height={40}
          width={200}
        />
        <Skeleton height={40} />
      </div>
      <Skeleton height={120} />
      <Skeleton height={120} />
      <Skeleton height={80} />
    </div>
  );
}
